// extracted by mini-css-extract-plugin
export default {"container":"AdminSearchingFor_container__BKvke","dotsAndHeadingWrapper":"AdminSearchingFor_dotsAndHeadingWrapper__SfaPT"};